/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inbox_Na_Proposal_ReviewInputs */

const en_inbox_na_proposal_review = /** @type {(inputs: Inbox_Na_Proposal_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Review the proposed change`)
};

const id_inbox_na_proposal_review = /** @type {(inputs: Inbox_Na_Proposal_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tinjau usulan perubahan`)
};

/**
* | output |
* | --- |
* | "Review the proposed change" |
*
* @param {Inbox_Na_Proposal_ReviewInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const inbox_na_proposal_review = /** @type {((inputs?: Inbox_Na_Proposal_ReviewInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbox_Na_Proposal_ReviewInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_inbox_na_proposal_review(inputs)
	return en_inbox_na_proposal_review(inputs)
});